export const iconFontAwesomeMapsLocationCrosshairs = (
	<i className="fa-solid fa-location-crosshairs"></i>
);
